module.exports = __webpack_public_path__ + "img/icon_img52.b72bb901.png";